'use client';

import { Button, Flex, Icon, Text } from '@chakra-ui/react';
import { useContext } from 'react';

import { AuthContext } from '@/contexts/AuthContext';
import { FaCheckCircle } from 'react-icons/fa';

const UserConfirmationSuccessfully = () => {
  const { handleChangeStatus } = useContext(AuthContext);

  return (
    <Flex flexDir="column" gap="20px" align="center">
      <Flex
        w="72px"
        h="72px"
        borderRadius="20px"
        bg="rgba(46,204,113,0.12)"
        align="center"
        justify="center"
        flexShrink={0}
      >
        <Icon width="36px" height="36px" color="#2ecc71">
          <FaCheckCircle />
        </Icon>
      </Flex>
      <Flex flexDir="column" align="center" gap="6px">
        <Text
          fontSize="20px"
          fontWeight="700"
          color={{ base: '#0A1B2B', _dark: '#E2EFF5' }}
        >
          Conta Confirmada!
        </Text>
        <Text
          fontSize="13px"
          textAlign="center"
          color={{ base: 'rgba(0,0,0,0.55)', _dark: 'rgba(255,255,255,0.45)' }}
        >
          A sua conta foi confirmada com sucesso.
        </Text>
      </Flex>

      <Button
        w="full"
        h="44px"
        borderRadius="full"
        bg="#00B0CA"
        color="white"
        fontWeight="700"
        fontSize="15px"
        boxShadow="0 4px 20px rgba(0,176,202,0.3)"
        onClick={() => handleChangeStatus('signin')}
        _hover={{ bg: '#009AB5' }}
        transition="all 0.2s"
      >
        Iniciar Sessão
      </Button>
    </Flex>
  );
};

export default UserConfirmationSuccessfully;
